import { InjectionToken } from '@angular/core';

import { TokenStatsFacade } from './token-stats.facade';

export const TOKEN_STATS_FACADE = new InjectionToken<TokenStatsFacade>(
  'TOKEN_STATS_FACADE'
);